module.exports = __webpack_public_path__ + "static/img/userlocationPin.500a6c7.svg";